import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, View } from "@/types";

export function useDeleteView() {
  const mutation = useMutation({
    mutationFn: async ({ id }: { id: number }) => {
      const path = `views/${id.toString()}`;
      const res = await guacHttpClient.delete<View, HttpResponse<View>>(path);
      return res.data;
    },
  });

  return mutation;
}
